import React from 'react'
import { useSpring, animated as a } from 'react-spring'
import { useStoreState, useStoreActions } from 'easy-peasy'

import { useIsDesktop } from '../hooks'
import { Box } from 'system'

export const Overlay = () => {
  const isNavOpen = useStoreState(state => state.nav.isNavOpen)
  const closeNav = useStoreActions(actions => actions.nav.closeNav)
  const animProps = useSpring({
    opacity: isNavOpen ? 0.4 : 0,
  })
  const isDesktop = useIsDesktop()

  return (
    !isDesktop && (
      <Box
        as={a.div}
        position="absolute"
        display={['block', 'none']}
        style={animProps}
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={2}
        minHeight="100vh"
        bg="black"
        css={`
          transition: visibility 0.5s;
          visibility: ${isNavOpen ? 'visible' : 'hidden'};
        `}
        onClick={closeNav}
      />
    )
  )
}

export default Overlay
